import Vue from 'vue'

export default {
    list(params) {
        return Vue.axios.get(`/sms-log`, {params})
    },
    listStatuses(params) {
        return Vue.axios.get(`/sms-log/statuses`)
    },
}
